import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-paragraph",
  "use": "icon-paragraph-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" class=\"bi bi-paragraph\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-paragraph\">\r\n  <path fill-rule=\"evenodd\" d=\"M8 1h4.5a.5.5 0 0 1 0 1H11v12.5a.5.5 0 0 1-1 0V2H9v12.5a.5.5 0 0 1-1 0V1z\" />\r\n  <path d=\"M9 1v8H7a4 4 0 1 1 0-8h2z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/paragraph.svg
// module id = TYH+
// module chunks = 60